import { capabilities_request } from './util'; 
import { createFromCapabilitiesMatrixSet } from 'ol/tilegrid/WMTS';
import { get } from 'ol/proj';

class Capabilities {
    
    constructor(capabilities) {
        this.capabilities = capabilities;
    }    
    
    getLayers() {
        return this.capabilities.Contents.Layer;
    }
    
    getTileMatrixSet({ TileMatrixSet }) {
        const tileMatrixSet = this.capabilities.Contents.TileMatrixSet;

        for (let i = 0, length = tileMatrixSet.length; i < length; i++) {
            const entry = tileMatrixSet[i];
            const { Identifier } = entry;
            if (Identifier === TileMatrixSet) {
                return entry;
            }
        }
    }
    
    getTileGrid(tileMatrixSet, link) {
        const { SupportedCRS } = tileMatrixSet;        
        const projection = get( SupportedCRS );

        if( projection != null ) {
            console.log(tileMatrixSet, projection);
            return createFromCapabilitiesMatrixSet(tileMatrixSet, projection.getExtent(), link.TileMatrixSetLimits);
        }
    }        
}


const wmts = async (url) => {
    const WMTSCapabilities = await import(/* webpackChunkName: "wmts_capabilities" */ 'ol/format/WMTSCapabilities').then(module => module.default);
    const response = await capabilities_request(url, "WMTS", "1.0.0", WMTSCapabilities);       
    
    const { Contents } = response || {};
    if (Contents && Contents.Layer) {
        return new Capabilities(response);
    }
}

export {
	wmts
}